let audioContext = null;

const BELL_FUNDAMENTAL = 1760;
const BELL_PARTIALS = [
  { ratio: 1, gain: 1 },
  { ratio: 2.76, gain: 0.28 },
  { ratio: 4.02, gain: 0.1 },
];
const STRIKE_DURATION = 0.9;
const STRIKE_GAP = 0.25;
const PEAK_GAIN = 0.22;

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextCtor) return null;
  if (!audioContext) audioContext = new AudioContextCtor();
  return audioContext;
}

function strike(audioCtx, when) {
  const master = audioCtx.createGain();
  master.connect(audioCtx.destination);
  master.gain.setValueAtTime(0.0001, when);
  master.gain.exponentialRampToValueAtTime(PEAK_GAIN, when + 0.005);
  master.gain.exponentialRampToValueAtTime(0.0001, when + STRIKE_DURATION);

  for (const partial of BELL_PARTIALS) {
    const oscillator = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.value = BELL_FUNDAMENTAL * partial.ratio;
    gain.gain.value = partial.gain;
    oscillator.connect(gain);
    gain.connect(master);
    oscillator.start(when);
    oscillator.stop(when + STRIKE_DURATION);
  }
}

export function playBell(strikes) {
  try {
    const audioCtx = getAudioContext();
    if (!audioCtx) return;
    if (audioCtx.state === 'suspended') {
      audioCtx.resume();
    }
    for (let i = 0; i < strikes; i += 1) {
      strike(audioCtx, audioCtx.currentTime + i * STRIKE_GAP);
    }
  } catch (error) {
    console.warn('Unable to play bell', error);
  }
}
